// extracted by mini-css-extract-plugin
export default {"wrapper":"Popup_wrapper__ACMeG","closeContainer":"Popup_closeContainer__Z0WZJ","close":"Popup_close__eT9CH","iframe":"Popup_iframe__NO16B","overlay":"Popup_overlay__Rlo3p"};